/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    bannerImage: '',
    bannerPosition: 1,
    link: '',
},

*/

document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function snizeAddCollectionBanner(snizeBannerUrl, snizeBannerPosition, snizeColUrl) {
            if (location.pathname.includes('/collections')) {
                $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                    <li class="snize-banner snize-custom-banner">
                        ${snizeColUrl ? `<a href=${snizeColUrl} target="_blank">` : ''}
                        <img src=${snizeBannerUrl}></a></li>`
                );
            }
        }

        let snizeBannersData = [
            {
                bannerImage: 'https://cdn.shopify.com/s/files/1/0746/2702/3131/files/20_Off_Liner_Combo-Promo.gif?v=1785278663',
                bannerPosition: 3,
                link: '',
            },
        ];

        $(document).on('Searchanise.ResultsUpdated', function () {
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.bannerImage, bannerData.bannerPosition, bannerData.link);
                });
            }
        });
    })(window.Searchanise.$);
});
